<div class="popup confirmDecisionPopup">
    <h1 class="confirmDecisionPopup-title _primary"[i18nKey]="'decisions.confirmation.popup.title'"></h1>

    <p class="confirmDecisionPopup-message">
        <span [i18nKey]="'decisions.confirmation.popup.message1'"></span>
        {{'common.restaurant.type.' + restaurantTypeChange.currentType + '.lowercase' | translate}}
        <span [i18nKey]="'decisions.confirmation.popup.message2'"></span>
        {{'common.restaurant.type.' + restaurantTypeChange.targetType + '.lowercase' | translate}}.
        <br /><br />
        <span [i18nKey]="restaurantTypeChange.staffChangeExplanationLabelKey"></span>
        <br /><br/>
        <span [i18nKey]="'decisions.confirmation.popup.message3'"></span>
        <br /><br/> <span [i18nKey]="'decisions.confirmation.popup.confirm'"></span>
    </p>

    <div class="confirmDecisionPopup-action">
        <button (click)="cancel()" class="button _cancel">{{cancelButtonMessage}}</button>
        <button (click)="confirm()" class="button">{{confirmButtonMessage}}</button>
    </div>
</div>
<div class="overlay"></div>
